import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth.tsx";
import { LegalAcceptanceGate } from "./components/LegalAcceptanceGate.tsx";
import Layout from "./components/Layout.tsx";
import Login from "./pages/Login.tsx";
import BusinessSelector from "./pages/BusinessSelector.tsx";
import CreateBusiness from "./pages/CreateBusiness.tsx";
import Onboarding from "./pages/Onboarding.tsx";
import Today from "./pages/Today.tsx";
import Calendar from "./pages/Calendar.tsx";
import Services from "./pages/Services.tsx";
import Staff from "./pages/Staff.tsx";
import Customers from "./pages/Customers.tsx";
import Products from "./pages/Products.tsx";
import Payments from "./pages/Payments.tsx";
import Settings from "./pages/Settings.tsx";
import Team from "./pages/Team.tsx";
import NotFound from "./pages/NotFound.tsx";

function AuthGuard() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500 text-sm">Loading...</div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return (
    <LegalAcceptanceGate>
      <Outlet />
    </LegalAcceptanceGate>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Auth-protected routes */}
      <Route element={<AuthGuard />}>
        <Route path="/" element={<BusinessSelector />} />
        <Route path="/create-business" element={<CreateBusiness />} />
        <Route path="/onboarding/:slug" element={<Onboarding />} />

        <Route path="/:slug" element={<Layout />}>
          <Route index element={<Today />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="services" element={<Services />} />
          <Route path="staff" element={<Staff />} />
          <Route path="customers" element={<Customers />} />
          <Route path="products" element={<Products />} />
          <Route path="payments" element={<Payments />} />
          <Route path="settings" element={<Settings />} />
          <Route path="team" element={<Team />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
